<div class="dynamic-options-container">
  <icn-dropdown
    class="dynamic-options-dropdown"
    [large]="true"
    [position]="'bottom'"
    [(selectedValue)]="dynamicOptionChosen"
  >
    <icn-dropdown-item
      *ngFor="let dynamicOption of dynamicOptions; let index = index"
      [title]="dynamicOption.displayName"
      [value]="dynamicOption"
    >
    </icn-dropdown-item>
  </icn-dropdown>

  <icn-dropdown
    class="dynamic-options-metadata-dropdown"
    *ngIf="
      !!dynamicOptionChosen &&
      (dynamicOptionChosen.displayName === 'Current Show' ||
        dynamicOptionChosen.displayName === 'Next Show' ||
        dynamicOptionChosen.displayName === 'Next Next Show' ||
        dynamicOptionChosen.displayName === 'Next(x3) Show' ||
        dynamicOptionChosen.displayName === 'Next Time' ||
        dynamicOptionChosen.displayName === 'Specific Time' ||
        dynamicOptionChosen.displayName === 'Tomorrow' ||
        dynamicOptionChosen.displayName === 'Next Week' ||
        dynamicOptionChosen.displayName === 'This Week')
    "
    [large]="true"
    [position]="'bottom'"
    [(selectedValue)]="metadataChosen"
  >
    <icn-dropdown-item
      title="Start Time AM/PM"
      value="***StartTime***"
    ></icn-dropdown-item>
    <icn-dropdown-item
      title="Start Time Rounded AM/PM"
      value="***StartTimeRounded***"
    ></icn-dropdown-item>
    <icn-dropdown-item
      title="Start Time 24H"
      value="***StartTime24h***"
    ></icn-dropdown-item>
    <icn-dropdown-item
      title="Start Time Rounded 24H"
      value="***StartTimeRounded24h***"
    ></icn-dropdown-item>
    <icn-dropdown-item
      *ngFor="let metadataEntry of metadata; let index = index"
      [title]="metadataEntry.name"
      [value]="metadataEntry.name"
    >
    </icn-dropdown-item>
  </icn-dropdown>

  <icn-dropdown
    class="dynamic-options-day-of-week-dropdown"
    *ngIf="
      !!dynamicOptionChosen &&
      (
        dynamicOptionChosen.displayName === 'Next Week' ||
        dynamicOptionChosen.displayName === 'This Week' ||
        dynamicOptionChosen.displayName === 'Specific Time')
    "
    [large]="true"
    [position]="'bottom'"
    [selectedValue]="-1"
    (listOpenChange)="onDayOfWeekClicked($event)"
  >
    <icn-dropdown-item [title]="formattedSelectedTime" [value]="-1" ></icn-dropdown-item>
  </icn-dropdown>

  <ngx-smart-modal
    #chooseDayAndTimePromptModal
    identifier="chooseDayAndTimePromptModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered'"
  >
    <evrideo-choose-day-and-time></evrideo-choose-day-and-time>
  </ngx-smart-modal>

  <icn-dropdown
    class="dynamic-options-timezone-dropdown"
    *ngIf="
      !!dynamicOptionChosen &&
      (
        dynamicOptionChosen.displayName === 'Next Time' ||
        dynamicOptionChosen.displayName === 'Tomorrow' ||
        dynamicOptionChosen.displayName === 'Next Week' ||
        dynamicOptionChosen.displayName === 'Specific Time' ||
        dynamicOptionChosen.displayName === 'This Week')
    "
    [large]="true"
    [position]="'bottom'"
    [(selectedValue)]="timeZoneChosen"
  >
    <icn-dropdown-item title="Channel's time zone" [value]="'channel_timezone'"></icn-dropdown-item>
    <icn-dropdown-item
      *ngFor="let timeZone of allTimeZones"
      [title]="timeZone.displayName"
      [value]="timeZone.value"
    >
    </icn-dropdown-item>
  </icn-dropdown>

  <icn-dropdown
    class="dynamic-options-tag-dropdown"
    *ngIf="
      !!dynamicOptionChosen &&
      (dynamicOptionChosen.displayName.indexOf('Next Show') >= 0 ||
        dynamicOptionChosen.displayName.indexOf('Next Next Show') >= 0 ||
        dynamicOptionChosen.displayName.indexOf('Next(x3) Show') >= 0 ||
        dynamicOptionChosen.displayName === 'Next Time' ||
        dynamicOptionChosen.displayName === 'Tomorrow' ||
        dynamicOptionChosen.displayName === 'Next Week' ||
        dynamicOptionChosen.displayName === 'This Week' ||
        dynamicOptionChosen.displayName === 'Specific Time')
    "
    [large]="true"
    [position]="'bottom'"
    [(selectedValue)]="tagChosen"

  >
    <icn-dropdown-item title="No Tag" [isDefault]="true" [value]="-1"></icn-dropdown-item>
    <icn-dropdown-item
      *ngFor="let tag of tags; let index = index"
      [title]="tag.name"
      [value]="tag.id"
    >
    </icn-dropdown-item>
  </icn-dropdown>

  <button class="btn btn-add" (click)="addDynamicOption()">Add</button>
</div>
